module.exports = __webpack_public_path__ + "media/images/mailer/gamification-9e8826590894657e55fce1f1774991d0.jpg";